// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Fetch from "bs-fetch/src/Fetch.bs.js";
import * as Tools from "../Tools.bs.js";
import * as React from "react";
import * as Config from "../Config.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function getProfile(token) {
  var requestInit = Fetch.RequestInit.make(/* Get */0, {
          Authorization: "Bearer " + token
        }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return fetch(Config.url, requestInit).then(Tools.parseJsonIfOk);
}

function useProfile(token) {
  var match = React.useState(function () {
        return /* Request */0;
      });
  var setState = match[1];
  React.useEffect((function () {
          Curry._1(setState, (function (param) {
                  return /* Request */0;
                }));
          getProfile(token).then(function (resp) {
                var tmp;
                if (resp.TAG === /* Ok */0) {
                  var x = resp._0;
                  try {
                    var match = x.tag;
                    switch (match) {
                      case "pre_registered" :
                          tmp = Curry._1(setState, (function (param) {
                                  return {
                                          TAG: /* SuccessPreRegisterdProfile */0,
                                          _0: Belt_Option.getExn(x.pre_registered)
                                        };
                                }));
                          break;
                      case "registered" :
                          tmp = Curry._1(setState, (function (param) {
                                  return {
                                          TAG: /* SuccessRegisterdProfile */1,
                                          _0: Belt_Option.getExn(x.registered)
                                        };
                                }));
                          break;
                      default:
                        tmp = Curry._1(setState, (function (param) {
                                return /* Failure */2;
                              }));
                    }
                  }
                  catch (exn){
                    tmp = Curry._1(setState, (function (param) {
                            return /* Failure */2;
                          }));
                  }
                } else {
                  var match$1 = resp._0.status;
                  tmp = match$1 !== 404 ? Curry._1(setState, (function (param) {
                            return /* Failure */2;
                          })) : Curry._1(setState, (function (param) {
                            return /* UserNotFound */1;
                          }));
                }
                return Promise.resolve(tmp);
              });
          
        }), []);
  return match[0];
}

export {
  getProfile ,
  useProfile ,
  
}
/* react Not a pure module */
